import { Component, HostListener, Inject } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MessageNotificationService } from 'message-notification-service-lib';
import {
  SUGGESTED_EXPLANATION_DIFFICULTY,
  SUGGESTED_FORMATS,
  SUGGESTED_LANGUAGES,
  SUGGESTED_RESULT_LENGTHS,
  SUGGESTED_ROLES,
  SUGGESTED_TONES,
} from '../../../constants/defaults';
import { ConfigService } from '../../../services/config.service';
import { IPromptOptions, IPromptProfileMeta } from '../../../types/IPromptProfileMeta';

@Component({
  selector: 'app-assist-manager-admin',
  templateUrl: './assist-manager-admin.component.html',
  styleUrls: ['./assist-manager-admin.component.scss'],
  standalone: false,
})
export class AssistManagerAdminComponent {
  protected readonly MAX_FILE_SIZE_MB = 5;
  private readonly MAX_FILE_SIZE_BYTES = this.MAX_FILE_SIZE_MB * 1024 * 1024;

  form: FormGroup;
  optionControl = new FormControl(); // TODO: Is this needed?
  placeholder = 'Search or enter languages...'; // TODO: This will be fed by an input
  promptOptions: IPromptOptions;

  protected readonly SUGGESTED_ROLES = SUGGESTED_ROLES;
  protected readonly SUGGESTED_TONES = SUGGESTED_TONES;
  protected readonly SUGGESTED_FORMATS = SUGGESTED_FORMATS;
  protected readonly SUGGESTED_RESULT_LENGTHS = SUGGESTED_RESULT_LENGTHS;
  protected readonly SUGGESTED_EXPLANATION_DIFFICULTIES = SUGGESTED_EXPLANATION_DIFFICULTY;
  protected readonly SUGGESTED_LANGUAGES = SUGGESTED_LANGUAGES;

  constructor(
    public dialogRef: MatDialogRef<AssistManagerAdminComponent>,
    @Inject(MAT_DIALOG_DATA) public promptProfileMeta: IPromptProfileMeta,
    private matDialog: MatDialog,
    private fb: FormBuilder,
    private clientConfigService: ConfigService,
    private messageNotificationService: MessageNotificationService,
  ) {
    this.promptOptions = this.promptProfileMeta.options;
    this.form = this.fb.group({
      // TODO: Does this need to exist, when we have chosenOptions?
      optionControl: this.optionControl,
    });
  }

  queueFileUpload(event: any): void {
    const file: File = event.files.item(0);
    if (file.size > this.MAX_FILE_SIZE_BYTES) {
      this.messageNotificationService.error(`File upload failed: File size exceeds ${this.MAX_FILE_SIZE_MB} MB limit`);
      return;
    }
    this.promptProfileMeta.baseHtmlStyleFile = { name: file.name, file: file };
  }

  downloadFile(): void {
    this.clientConfigService.downloadBaseHtmlStyleFile().subscribe((blob) => {
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = this.promptProfileMeta.baseHtmlStyleFile?.name;
      a.click();
      URL.revokeObjectURL(url);
    });
  }

  clearFile(): void {
    this.promptProfileMeta.baseHtmlStyleFile = undefined;
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  onSave(): void {
    this.dialogRef.close(this.promptProfileMeta);
  }

  // Keyboard Shortcut - Use Esc to clear
  @HostListener('document:keydown', ['$event'])
  protected handleKeydownEvent(event: KeyboardEvent) {
    if (this.matDialog.openDialogs.length === 1) {
      if (event.code === 'Escape') {
        this.onCancel();
      }
    }
  }
}
